@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.container {
  position: relative;
  margin-top: 0;
  margin-bottom: 1rem;

  h3 {
    margin-top: 2rem;

    @include mobile {
      margin-top: 1rem;
    }
  }
}

.center-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.referral-info {
  margin: 0;
  font-weight: 300;
  font-size: 1em;
  line-height: 1.5rem;

  @include mobile {
    font-size: 0.75rem;
    line-height: 1.125rem;
    font-weight: 300;
  }
}

.link-container {

  margin: 2rem auto 1.5rem;
  box-sizing: border-box;
  width: 66%;
  position: relative;

  @include touch {
    padding-right: 0;
    width: 100%;
  }

  .link {
    width: 100%;
    padding-top: .6rem;
    padding-bottom: .6rem;
    box-sizing: border-box;
    font-weight: 300;
    color: $grey-text;
    border: 1px solid $separator;
    text-align: center;
    font-size: 1.125rem;

    @include touch {
      font-size: 1rem;
    }
  }

  .icon {
    position: absolute;
    right: 0;
    top: -3.2rem;

    @include touch {
      display: none;
    }
  }

  .iconsize {
    width: 13rem;
    height: 13rem
  }
}

.design-element {
  height: 30px;
  width: 400px;
  margin-left: 2rem;

  @include mobile {
    width: 100%;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

.social-media-container {

  margin-bottom: 2.375rem;
  text-align: center;

  .shareButton {
    &:hover {
      fill: #00d1b2;
    }
  }

  @include mobile {
    margin-left: 0;
    margin-right: 0;
  }
}
